import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { TimeUtil } from './utils/timeUtil';

// 设置服务器时区
const serverTimezone = process.env.REACT_APP_SERVER_TIMEZONE || 'Asia/Shanghai';
TimeUtil.setServerTimezone(serverTimezone);
console.log(`[时区设置] 前端服务器时区已设置为: ${serverTimezone}`);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
